import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
export const LauncherBarStack = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(2, 4),
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: 'rgb(242, 242, 242)',
    gap: theme.spacing(2),
    cursor: 'pointer'
}));
export const LogoContainerBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 171, 186, 1)', // connect blue
    width: 32,
    height: 32,
    borderRadius: 16,
    // we need this to position the status color relative to this
    // container
    position: 'relative'
});
export const StatusHintBox = styled(Box)({
    position: 'absolute',
    // anchor to the bottom right, relative to parent,
    // offset by border width
    right: -2,
    bottom: -2,
    height: 8,
    width: 8,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: 'white',
    borderStyle: 'solid',
    boxSizing: 'content-box'
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGF1bmNoZXJCYXIuc3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQW1hem9uQ29ubmVjdENjcExhdW5jaGVyL0xhdW5jaGVyQmFyLnN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxHQUFHLE1BQU0sbUJBQW1CLENBQUM7QUFDcEMsT0FBTyxLQUFLLE1BQU0scUJBQXFCLENBQUM7QUFDeEMsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBRzlDLE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFrRCxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzNHLGFBQWEsRUFBRSxLQUFLO0lBQ3BCLFVBQVUsRUFBRSxRQUFRO0lBQ3BCLE9BQU8sRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDNUIsbUJBQW1CLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFDckMsb0JBQW9CLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFDdEMsc0JBQXNCLEVBQUUsQ0FBQztJQUN6Qix1QkFBdUIsRUFBRSxDQUFDO0lBQzFCLGVBQWUsRUFBRSxvQkFBb0I7SUFDckMsR0FBRyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0lBQ3JCLE1BQU0sRUFBRSxTQUFTO0NBQ2xCLENBQUMsQ0FBQyxDQUFDO0FBRUosTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQWdELE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUN2RixPQUFPLEVBQUUsTUFBTTtJQUNmLGNBQWMsRUFBRSxRQUFRO0lBQ3hCLFVBQVUsRUFBRSxRQUFRO0lBQ3BCLGVBQWUsRUFBRSxzQkFBc0IsRUFBRSxlQUFlO0lBQ3hELEtBQUssRUFBRSxFQUFFO0lBQ1QsTUFBTSxFQUFFLEVBQUU7SUFDVixZQUFZLEVBQUUsRUFBRTtJQUNoQiw2REFBNkQ7SUFDN0QsWUFBWTtJQUNaLFFBQVEsRUFBRSxVQUFVO0NBQ3JCLENBQUMsQ0FBQztBQUVILE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBZ0QsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ3BGLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLGtEQUFrRDtJQUNsRCx5QkFBeUI7SUFDekIsS0FBSyxFQUFFLENBQUMsQ0FBQztJQUNULE1BQU0sRUFBRSxDQUFDLENBQUM7SUFDVixNQUFNLEVBQUUsQ0FBQztJQUNULEtBQUssRUFBRSxDQUFDO0lBQ1IsWUFBWSxFQUFFLENBQUM7SUFDZixXQUFXLEVBQUUsQ0FBQztJQUNkLFdBQVcsRUFBRSxPQUFPO0lBQ3BCLFdBQVcsRUFBRSxPQUFPO0lBQ3BCLFNBQVMsRUFBRSxhQUFhO0NBQ3pCLENBQUMsQ0FBQyJ9